import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges , ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { GmsapidataService } from '../../../../app/core/services/gmsapidata.service';
import { GmsdialogService } from '../../../../app/shared/services/gmsdialog.service';
import { CommonService } from '../../../core/services/common.service';
import { FeatureOperationsService } from '../../../shared/services/feature-operations/feature-operations.service';
import { GmsconfirmComponent } from '../../dialogs/gmsconfirm/gmsconfirm.component';
import { ImultiMediaData } from '../../interfaces/gmsdata.interface';
import { SoundManagerService } from '../../services/sound-manager/sound-manager.service';
import { UtilService } from '../../services/util/util.service';

@Component({
    selector: 'app-label-assets-upload',
    templateUrl: './label-assets-upload.component.html',
    styleUrls: ['./label-assets-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LabelAssetsUploadComponent implements OnInit, OnDestroy {
  @Input() name;
  @Input() configObj;
  @Input() isUploadMultimedia;
  @Input() isOnPoints;
  @Output() getChildData = new EventEmitter();
  @Output() isSuccessfullUpload = new EventEmitter();
  @Output() updateFeatureDetails = new EventEmitter();
  @Output() isNewAssetUpload = new EventEmitter();
  private isNewFileUpload: boolean = false;
  private maxFileSizeAllowed = 300 // in Kb;
  private fNameTimeoutId: any;
  private fDataTimeoutId: any;
  public isLoading: boolean = false;
  public isLabelSelected: boolean = false;

  constructor(private gmsapidataService: GmsapidataService, private gmsAlertSer: GmsdialogService,
    private FtOpSer: FeatureOperationsService, private modalRef: NgbModal,
    private CmnServ: CommonService, private router: Router, private soundManager: SoundManagerService,
    private utilService: UtilService) { }

  private getLabelsSub: Subscription;
  private getFontsSub: Subscription;
  public allLabelsArray = [];
  public featureType;
  public selectedLabel = "";
  public selectedType = "defAssets";
  public introText = ""; // for wab
  public labelColor: any;
  public defaultIntroText = "Welcome to Whack A Bingo Chat"; // for wab
  public defLabelColor: any;
  public assetsInfo: any = {};
  private allAssetsDetails: any = {};
  public mode;
  private multimediaData: ImultiMediaData;
  public wabLabelsArr = [];
  private originalFeatureName = "";
  public isPreviewEnabled: boolean = false;
  public isDefPreview: boolean = false;
  public previewFeatures = ["whack_a_bingo", "whack_a_bingo_chat"]; // can be handled from Dynacon
  public selectedFont: any = '';
  public predefinedFontsList = [];
  public fontDataObj: any = {};
  // public isWAB: boolean = false;

  ngOnInit(): void {
    let { callingPage, mode } = this.configObj;
    this.featureType = callingPage;
    this.mode = mode;
    // this.isWAB = (this.featureType == ('whack_a_bingo' || "whack_a_bingo_chat"));
    if (this.isWABFeature) {
      this.defaultIntroText = (this.featureType == 'whack_a_bingo' ? 'Welcome to Whack A Bingo' : this.defaultIntroText);
      this.defLabelColor = {
        "welcome_title": "#380303",
        "table_header_bg": "#082BA6",
        "table_header_text": "#fff",
        "sub_header_text": "#000;",
        "sub_header_bg_color": "rgba(8, 43, 166, 0.1)",
        "table_row_bg": "#E6ECFF",
        "table_row_text": "#000",
        "tickets_table_row_bg": "#E6ECFF",
        "tickets_table_row_color": "#000",
        "header_bg": "#082BA6",
        "header_text": "#fff",
        "how_to_play_heading": "#000",
        "how_to_play_text": "#000",
        "rules_heading": "#000",
        "rules_text": "#000",
        "tnc_text": "#000",
        "play_here_text": "#000",
        "wab_chat_ranks_header_color": "#082BA6",
        "wab_chat_ranks_text_color": "#000000",
        "wab_chat_ranks_text_bg_color": "#E6ECFF",
        "wab_chat_ranks_header_text_color": "#ffffff"
      }
    }
    this.labelColor = this.defLabelColor;
    if (mode == "create") {
      if (this.isWABFeature) {
        this.introText = this.defaultIntroText;
      }
    } else if (mode == "copy") { // In copy case, to pass original_feature_name in multimedia_upload API call
      this.fNameTimeoutId = setTimeout(() => {
        this.originalFeatureName = this.name?.slice(0, this.name.length - 5);
      }, 1000);
    }
    this.getLabelsList();
    if (this.isWABFeature) {
      this.getPredefinedFontsList();
      this.initializeFontData();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.isUploadMultimedia?.currentValue) {
      this.uploadAllAssets();
    }

    if (changes?.isOnPoints?.previousValue != changes?.isOnPoints?.currentValue) {
      this.setDefaultColors();
    }
  }

  getLabelsList() {
    this.getLabelsSub = this.gmsapidataService.getLabels().subscribe(response => {
      if (response.data != null && response.data != "") {
        this.allLabelsArray = response.data;
        if (this.mode == 'create') {
          this.assetsInfo = { ...this.configObj?.assets };
          this.allLabelsArray.forEach(eachLabel => {
            eachLabel["isAssetsUploaded"] = false;
          });
          if (this.isWABFeature) {
            this.wabLabelsArr = this.allLabelsArray.map(label => {
              let result = {
                "welcome_title": this.defaultIntroText,
                "custom_assets": false,
                "brand_id": label.name,
                "color_code": this.defLabelColor
              };
              return result;
            });
            this.updateFeatureDetails.emit(this.wabLabelsArr);
          }
        } else {
          this.isLoading = true;
          this.assetsInfo = this.FtOpSer.getFeatureAssetData();
          this.fDataTimeoutId = setTimeout(() => {
            let { uploadedLabels } = this.configObj;
            if (this.isWABFeature) {
              this.wabLabelsArr = this.configObj["featureInfo"].wabLabelsArr;
            }
            for (let eachLabel of this.allLabelsArray) {
              eachLabel.isAssetsUploaded = uploadedLabels.includes(eachLabel.name);
            }
            this.setFeatureEditData();
          }, 2000);
        }
        this.isDefPreview = (this.selectedType == 'defAssets');
      }
    });
  }

  getPredefinedFontsList() {
    this.getFontsSub = this.gmsapidataService.getFontsList().subscribe(response => {
      if (response) {
        this.predefinedFontsList = response.fonts_list;
      }
    });
  }

  initializeFontData() {
    this.fontDataObj = {
      "font_info": {
        "font_name": '',
        "font_file_info": {
          "regular": {
            "file_data": '',
            "file_path": ''
          },
          "bold": {
            "file_data": '',
            "file_path": ''
          }
        }
      },
      "font_type": ''
    };
  }

  setFeatureEditData() {
    this.allAssetsDetails = {};
    this.configObj?.assets?.forEach(eachLabel => {
      for (let [label, assets] of Object.entries(eachLabel)) {
        let featureAssetObj = this.FtOpSer.getFeatureAssetData();
        for (let [assetType, assetsArray] of Object.entries(featureAssetObj)) {
          this.allAssetsDetails[label] = {
            ...this.allAssetsDetails[label],
            [assetType]: assetsArray
          };
        }

        for (let [key, path] of Object.entries(assets)) {
          for (let assetType of Object.keys(featureAssetObj)) {
            let isAssetFound = false;
            if (featureAssetObj[assetType].findIndex(each => each.val == key) != -1) {
              this.allAssetsDetails[label][assetType].forEach(item => {
                if (item.val == key && path) {
                  item.path = '/bingo_shared_assets/' + path + '?' + this.getRandomNumber();
                  item.extension = path.substring(path.lastIndexOf('.'));
                  isAssetFound = true;
                }
              });
              if (isAssetFound) break;
            }
          }
        }
      }
    });
    this.isLoading = false;
  }

  onLabelChange() {
    let isUploadedLabel = Object.keys(this.allAssetsDetails).includes(this.selectedLabel);
    if (isUploadedLabel) {
      this.selectedType = "uploadAssets";
      this.assetsInfo = this.allAssetsDetails[this.selectedLabel];
    } else {
      this.selectedType = "defAssets";
      this.assetsInfo = this.FtOpSer.getFeatureAssetData();
    }
    this.isDefPreview = (this.selectedType == 'defAssets');
    if (this.isWABFeature) {
      let labelIndex = this.getSelectedLabelIndex(this.wabLabelsArr, "brand_id");
      if (labelIndex != -1) {
        this.setDefaultColors();
        this.introText = this.wabLabelsArr[labelIndex]?.welcome_title;
        if (this.mode != 'create' && ((typeof this.wabLabelsArr[labelIndex]?.color_code) == 'string')) {
          this.labelColor.welcome_title = this.wabLabelsArr[labelIndex]?.color_code;
        } else {
          this.labelColor = this.wabLabelsArr[labelIndex]?.color_code;
        }
      }
      if (this.mode != 'create') {
        this.fontDataObj.font_info = this.wabLabelsArr[labelIndex]?.fonts_data ?? {};
        this.fontDataObj.font_type = this.wabLabelsArr[labelIndex]?.font_type ?? '';
        if (!this.fontDataObj.font_type || this.fontDataObj.font_type == '') {
          this.initializeFontData();
        }
        if (this.fontDataObj.font_type == 'custom') {
          this.fontDataObj.font_info['font_file_info']['regular']['file_path'] = this.wabLabelsArr[labelIndex]?.fonts_data?.font_file_info?.regular?.file_path;
          this.fontDataObj.font_info['font_file_info']['bold']['file_path'] = this.wabLabelsArr[labelIndex]?.fonts_data?.font_file_info?.bold?.file_path;
        }
        this.selectedFont = this.fontDataObj.font_type == 'predefined' ? this.fontDataObj.font_info.font_name : '';
      } else {
        this.initializeFontData();
        this.selectedFont = '';
      }
    }
  }

  onTypeChange() {
    this.soundManager.clearInstancePool();
    if (this.selectedType == 'defAssets') {
      let ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false
      };
      const modalRef = this.modalRef.open(GmsconfirmComponent, ngbModalOptions);
      modalRef.componentInstance.configObj = {
        "title": 'Confirmation',
        "message": `Are you sure you want to change the Asset Type to Default Assets ?
        <br><br>
        <b>Note:</b> Uploaded Assets for <span class="text-danger"><b>${this.selectedLabel}</b></span> Label will be deleted.
        `,
        "btnOkText": 'Ok',
        "btnCancelText": 'Cancel'
      };
      modalRef.componentInstance.confirmed.subscribe((result) => {
        if (result && result == true) {
          if (this.isWABFeature) {
            this.introText = this.defaultIntroText;
          }
          if (this.allAssetsDetails.hasOwnProperty(this.selectedLabel)) {
            delete this.allAssetsDetails[this.selectedLabel];
            this.getChildData.emit(Object.keys(this.allAssetsDetails));
            this.allLabelsArray[this.getSelectedLabelIndex(this.allLabelsArray, "name")].isAssetsUploaded = false;
            this.wabLabelsArr[this.getSelectedLabelIndex(this.wabLabelsArr, "brand_id")].custom_assets = false;
            delete this.wabLabelsArr[this.getSelectedLabelIndex(this.wabLabelsArr, "brand_id")]?.revision;
          }
          // console.log("Clicked OKay");
        } else {
          this.selectedType = 'uploadAssets';
          // console.log("Cancel and dismiss");
        }
        // console.log("Removed the Data", this.allAssetsDetails);
      });
    } else {
      let isUploadedLabel = Object.keys(this.allAssetsDetails).includes(this.selectedLabel);
      this.assetsInfo = isUploadedLabel ? this.allAssetsDetails[this.selectedLabel] : this.FtOpSer.getFeatureAssetData();
      // this.getChildData.emit(Object.keys(this.allAssetsDetails));
    }
  }

  updateIntroText() {
    let labelIndex = this.getSelectedLabelIndex(this.wabLabelsArr, "brand_id");
    if (labelIndex != -1) {
      this.wabLabelsArr[labelIndex].welcome_title = this.introText;
    }
    this.updateFeatureDetails.emit(this.wabLabelsArr); // need to update on each text change.
  }

  onColorChange() {
    let labelIndex = this.getSelectedLabelIndex(this.wabLabelsArr, "brand_id");
    if (labelIndex != -1) {
      this.wabLabelsArr[labelIndex].color_code = this.labelColor;
    }
    this.updateFeatureDetails.emit(this.wabLabelsArr); // need to update on each color change
  }

  isReqAssetsUploaded() {
    for (let assetType of this.objectKeys(this.assetsInfo)) {
      for (let each of this.assetsInfo[assetType]) {
        if (each.isRequired && !each.path) {
          return false;
        }
      }
    }
    return true;
  }

  validateFeatureInfo() {
    let labelIndex = this.getSelectedLabelIndex(this.wabLabelsArr, "brand_id");
    if (labelIndex != -1) {
      for (let each of this.wabLabelsArr) {
        if (!each.welcome_title) {
          return false;
        }
      }
      return true;
    }
  }

  uploadAFile(uploadedFile, assetObj, type, fontType?) {
    let uploadedFileData = uploadedFile.target?.files[0] as File;
    if (type == 'fonts') {
      // console.log(uploadedFileData);
      let existingFileNameIndx = this.validateFontFileName(uploadedFileData.name);
      let fontName = uploadedFileData.name.substring(0, uploadedFileData.name.lastIndexOf('.')).toLowerCase();
      let extension = uploadedFileData.name.substring(uploadedFileData.name.lastIndexOf('.')).toLowerCase();
      if (!this.validateFonts(fontName, fontType)) {
        return;
      };
      if (existingFileNameIndx == -1) {
        this.multimediaData = {
          "fileType": type.slice(0, -1),
          "fileData": uploadedFileData,
          "acceptedTypes": ['woff', 'woff2'],
          "maxSize": this.maxFileSizeAllowed,
        }
        this.CmnServ.convertToBase64Data(this.multimediaData, (response) => {
          if (response.status) {
            this.isNewFileUpload = true;
            this.fontDataObj["font_info"]["font_name"] = fontName;
            this.fontDataObj["font_info"]["font_file_info"][fontType] = {
              "file_data": response.imageData,
              "file_path": fontName + '-' + fontType + extension
            };
            this.fontDataObj["font_type"] = 'custom';
          } else {
            this.utilService.snackMsg(response.msg);
          }
          if (<HTMLInputElement>document.getElementById(fontType== 'regular' ? 'fontR' : 'fontB')) {
            (<HTMLInputElement>document.getElementById(fontType== 'regular' ? 'fontR' : 'fontB')).value = '';
          }
        });
      } else {
        this.utilService.snackMsg('Font File with the same name already exists. Please check in Predefined fonts list');
      }
    }
    else {
      let { val, maxFileSize, allowedTypes, maxHeight, maxWidth, isFixed } = assetObj;
      this.multimediaData = {
        "fileType": type.slice(0, -1),
        "fileData": uploadedFileData,
        "acceptedTypes": allowedTypes,
        "maxSize": maxFileSize ?? this.maxFileSizeAllowed,
        "maxWidth": maxWidth,
        "maxHeight": maxHeight,
        "isFixed": isFixed
      }
      // console.log(this.multimediaData);
      this.CmnServ.convertToBase64Data(this.multimediaData, (response) => {
        if (response.status) {
          this.isNewFileUpload = true;
          this.assetsInfo[type].forEach(each => {
            if (each.val == val) {
              each.path = response.imageData;
              // console.log("--->", each.path);
              each.extension = uploadedFileData.name.substring(uploadedFileData.name.lastIndexOf('.'));
            }
          });
        } else {
          this.utilService.snackMsg(response.msg);
        }
        if (<HTMLInputElement>document.getElementById(val)) {
          (<HTMLInputElement>document.getElementById(val)).value = '';
        }
      });
    }
  }

  saveMultimedia() {
    let labelIndex = this.getSelectedLabelIndex(this.wabLabelsArr, "brand_id");
    if (this.isWABFeature) {
      let dateNow = Date.now();
      if (labelIndex != -1) {
        this.wabLabelsArr[labelIndex]["revision"] = dateNow;
        if (this.fontDataObj.font_type != '') {
          this.wabLabelsArr[labelIndex]['fonts_data'] = this.fontDataObj.font_info;
          this.wabLabelsArr[labelIndex]['font_type'] = this.fontDataObj.font_type;
          if (this.fontDataObj.font_type == 'predefined' && this.selectedFont) {
            let idx = this.predefinedFontsList.findIndex(x => x.font_name == this.selectedFont);
            this.wabLabelsArr[labelIndex]['fonts_data']['font_file_info']['regular']['file_path'] = this.predefinedFontsList[idx]['font_file_info']['regular'];
            this.wabLabelsArr[labelIndex]['fonts_data']['font_file_info']['bold']['file_path'] = this.predefinedFontsList[idx]['font_file_info']['bold'];
          } else if (this.fontDataObj.font_type == 'custom' && this.fontDataObj.font_info?.font_file_info?.regular?.file_data != '' && this.fontDataObj.font_info?.font_file_info?.regular?.file_data != null
            && this.fontDataObj.font_info?.font_file_info?.bold?.file_data != '' && this.fontDataObj.font_info?.font_file_info?.bold?.file_data != null
          ) {
            this.wabLabelsArr[labelIndex]['fonts_data']['font_file_info']['regular']['file_data'] = this.CmnServ.convertToURLEncodeBase64(this.fontDataObj.font_info.font_file_info.regular.file_data);
            this.wabLabelsArr[labelIndex]['fonts_data']['font_file_info']['bold']['file_data'] = this.CmnServ.convertToURLEncodeBase64(this.fontDataObj.font_info.font_file_info.bold.file_data);
          } else {
            return;
          }
        } else {
          this.wabLabelsArr[labelIndex]['fonts_data'] = {};
          this.wabLabelsArr[labelIndex]['font_type'] = '';
        }
      }
    }
    if (this.selectedType == 'uploadAssets') {
      let uploadedLabelInd = this.allLabelsArray.findIndex(item => item.name == this.selectedLabel);
      this.allLabelsArray[uploadedLabelInd].isAssetsUploaded = true;
      this.allAssetsDetails[this.selectedLabel] = this.assetsInfo;
      this.utilService.snackMsg(`Assets Saved Successfully for ${this.selectedLabel}.`);
      this.isNewAssetUpload.emit(this.isNewFileUpload);
      this.getChildData.emit(Object.keys(this.allAssetsDetails));
      if (this.isWABFeature) {
        this.wabLabelsArr[labelIndex].custom_assets = true;
        this.updateFeatureDetails.emit(this.wabLabelsArr);
      }
    } else {
      this.utilService.snackMsg('Saved successfully');
    }
  }

  uploadAllAssets() {
    let uploadedLablesCount = 0;
    let isUploadEvntEmit = false;
    let { assetTypes } = this.configObj;
    // for (let [label, obj] of Object.entries(this.allAssetsDetails)) {
    Object.entries(this.allAssetsDetails).forEach(([label, obj], index) => {
      let reqObj = {
        "label_specific_asset": true,
        "label_name": label
      }
      if (this.mode == 'copy') { // these two keys should be there in the req payload only in case of clone
        reqObj["clone"] = true;
        reqObj["original_feature_name"] = this.originalFeatureName;
      }
      let assets = this.objectKeys(this.assetsInfo);
      let asset_details = [];
      for (let asset of assets) {
        obj[asset].forEach(each => {
          let { val, extension, path } = each;
          if (path) {
            let image = {
              "name": assetTypes[asset],
              "image_path": this.name + '_' + val + extension,
              "image_data": path,
              "index": val
            };
            if (this.mode == 'copy') {
              if (!(image.image_data.startsWith("data"))) {
                image.image_data = "";
              } else {
                let encodedBase64 = this.CmnServ.convertToURLEncodeBase64(image.image_data);
                image.image_data = encodedBase64;
              }
              asset_details.push(image);
            } else {
              if (image.image_data.startsWith("data")) {
                let encodedBase64 = this.CmnServ.convertToURLEncodeBase64(image.image_data);
                image.image_data = encodedBase64;
                asset_details.push(image);
              }
            }
          }
        });
      }
      reqObj["asset_details"] = asset_details;

      if (asset_details.length > 0) {
        let uploadedAssetsInfo = {};
        this.utilService.multimediaAPI(reqObj, response => {
          if (response) {
            uploadedAssetsInfo[label] = [];
            response.forEach(item => {
              if (!(item?.status)) {
                uploadedAssetsInfo[label].push(item?.index);
              }
            });
          }
          uploadedLablesCount += 1;
          if (uploadedLablesCount == Object.keys(this.allAssetsDetails).length) {
            this.isSuccessfullUpload.emit(uploadedAssetsInfo);
            isUploadEvntEmit = true;
          }
        });
      }

      if (!isUploadEvntEmit && (index == (Object.keys(this.allAssetsDetails).length - 1))) {
        this.isSuccessfullUpload.emit({});
      }
    });
  }

  redirectToFeaturesList() {
    this.router.navigate(['gmsnavmenu/gamemanagement/game-attrs-config/get-feature-list'], { queryParams: { featureName: this.featureType } });
  }

  objectKeys(object) {
    return Object.keys(object);
  }

  getRandomNumber() {
    return new Date().getTime();
  }

  getSelectedLabelIndex(array, key) {
    return array.findIndex(label => label[key] == this.selectedLabel);
  }

  get isPreviewFeature() {
    return this.previewFeatures.includes(this.featureType);
  }

  get isWABFeature() {
    return (this.featureType == 'whack_a_bingo') || (this.featureType == 'whack_a_bingo_chat');
  }

  onPreview() {
    if (!this.validateFeatureInfo()) {
      this.utilService.snackMsg("Please Enter all required fields");
      return;
    }
    if (this.isWABFeature) {
      if (!this.validateFonts()) {
        return;
      }
    }

    this.isDefPreview = (this.selectedType == 'defAssets');
    let soundsData = {};
    this.assetsInfo["sounds"].forEach(eachSound => {
      if (this.isDefPreview) {
        soundsData[eachSound.val] = eachSound.defPath;
      } else {
        if (eachSound.path) {
          soundsData[eachSound.val] = eachSound.path;
        }
      }
    });
    if (Object.keys(soundsData).length > 0) {
      this.soundManager.loadSounds(soundsData);
    }
    this.isPreviewEnabled = true;
  }

  validateFonts(fileName?, fontType?) {
    let reg_path = this.getDisplayFileName(this.fontDataObj.font_info.font_file_info.regular.file_path);
    let bold_path = this.getDisplayFileName(this.fontDataObj.font_info.font_file_info.bold.file_path);
    if (this.fontDataObj.font_type == 'predefined' && !this.selectedFont) {
      this.utilService.snackMsg('Please select/upload Font file');
      return false;
    } else if (this.fontDataObj.font_type == 'custom') {
      let cmpreName = fontType == 'regular' ? bold_path?.substring(0, bold_path?.lastIndexOf('-')).toLowerCase() : reg_path?.substring(0, reg_path?.lastIndexOf('-')).toLowerCase();
      if ((!fontType && reg_path && bold_path && (bold_path.substring(0, bold_path.lastIndexOf('-')).toLowerCase() != cmpreName)) ||
        (fontType == 'regular' && (bold_path && !reg_path) &&
          fileName != cmpreName) ||
        ((fontType == 'bold' && (reg_path && !bold_path) &&
          fileName != cmpreName))
      ) {
        this.utilService.snackMsg('Please make sure to have same file name for both regular & bold fonts');
        return false;
      }
    } else if (this.fontDataObj.font_type == 'custom' && (!this.fontDataObj.font_info.font_file_info.regular.file_data || this.fontDataObj.font_info.font_file_info.bold.file_data)) {
      this.utilService.snackMsg('Please upload both regular & bold font files');
      return false;
    }
    return true;
  }

  OnPreviewConfirm(isAssetsConfirmed) {
    this.isPreviewEnabled = false;
    this.soundManager.stopAll();
    if (isAssetsConfirmed) {
      this.saveMultimedia();
    }
  }

  playWabSounds(soundName) {
    this.soundManager.playSound(soundName);
  }

  onFontSelect(event) {
    let index = this.predefinedFontsList.findIndex(each => each.font_name == this.selectedFont);
    if (index != -1) {
      let obj = {
        'font_file_info': {
          'regular': { 'file_path': this.predefinedFontsList[index]['font_file_info'].regular },
          'bold': { 'file_path': this.predefinedFontsList[index]['font_file_info'].bold }
        },
        'font_name': this.predefinedFontsList[index].font_name
      }
      Object.assign(this.fontDataObj['font_info'], obj);
    }
  }

  validateFontFileName(fileName) {
    let index = this.predefinedFontsList.findIndex(each =>
      each.font_name.toLowerCase() == fileName.substring(0, fileName.lastIndexOf('.')).toLowerCase()
    );
    return index;
  }

  onSaveColors(data) {
    let labelIndex = this.getSelectedLabelIndex(this.wabLabelsArr, "brand_id");
    if (labelIndex != -1) {
      this.wabLabelsArr[labelIndex]['color_code'] = data?.colorCode || this.defLabelColor;
      this.labelColor = data?.colorCode || this.defLabelColor;
      if (data?.colorCode == null) {
        this.setDefaultColors();
      }
    }
    this.utilService.snackMsg('Colors updated successfully');
  }

  setDefaultColors() {
    this.isLabelSelected = false;
    this.labelColor = this.defLabelColor;
    setTimeout(() => {
      this.isLabelSelected = true;
    }, 1000);
  }

  toggleFontTypeRadio(event) {
    let selectedValue = event.target.value;
    this.fontDataObj.font_type = (selectedValue == this.fontDataObj.font_type) ? '' : selectedValue;
  }

  getDisplayFileName(path) {
    if (path && path.includes('bingo/assets/fonts/')) {
      return (path.substring(path.lastIndexOf('/') + 1));
    }
    return (path ?? '');
  }

  ngOnDestroy() {
    if (this.getLabelsSub) {
      this.getLabelsSub.unsubscribe();
    }
    if (this.getFontsSub) {
      this.getFontsSub.unsubscribe();
    }
    if (this.fNameTimeoutId) {
      clearTimeout(this.fNameTimeoutId);
    }
    if (this.fDataTimeoutId) {
      clearTimeout(this.fDataTimeoutId);
    }
    this.soundManager.clearInstancePool();
  }

}